// cart drawer
(function () {
  var root = function () { return document.querySelector('[data-pb-cd]'); };
  var sid = function () { var r = root(); return r && r.dataset.sectionId; };
  var open = function () { var r = root(); if (!r) return; r.classList.add('is-open'); document.documentElement.classList.add('pb-cd-lock'); };
  var close = function () { var r = root(); if (!r) return; r.classList.remove('is-open'); document.documentElement.classList.remove('pb-cd-lock'); };
  var paint = function (html) {
    var r = root(); if (!r || !html) return;
    var d = new DOMParser().parseFromString(html, 'text/html');
    var n = d.querySelector('[data-pb-cd-inner]'), cur = r.querySelector('[data-pb-cd-inner]');
    if (!n || !cur) return;
    cur.innerHTML = n.innerHTML; cur.dataset.count = n.dataset.count;
    document.querySelectorAll('[data-pb-cart-count]').forEach(function (e) { e.textContent = n.dataset.count; });
  };
  var busy = function (on) { var r = root(); if (r) r.classList.toggle('is-busy', on); };
  var refresh = function () {
    return fetch('/?sections=' + encodeURIComponent(sid())).then(function (r) { return r.json(); }).then(function (j) { paint(j[sid()]); });
  };
  var post = function (url, body) {
    busy(true);
    body.sections = sid();
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j.sections) paint(j.sections[sid()]); else return refresh(); })
      .then(function () { busy(false); }, function () { busy(false); });
  };
  // Shopify splits a product into several cart lines when an automatic discount applies,
  // so set the total for a variant on its first line and zero the others.
  var setQty = function (vid, q) {
    busy(true);
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var first = true;
      var arr = c.items.map(function (i) {
        if (i.variant_id != vid) return i.quantity;
        if (first) { first = false; return q; }
        return 0;
      });
      return post('/cart/update.js', { updates: arr });
    }, function () { busy(false); });
  };
  window.pbCart = { open: open, close: close, refresh: refresh };
  document.addEventListener('click', function (e) {
    var t = e.target;
    var o = t.closest('[data-pb-cd-open]');
    if (o && root()) { e.preventDefault(); open(); refresh(); return; }
    if (t.closest('[data-pb-cd-close]')) { close(); return; }
    var m = t.closest('[data-pb-cd-minus],[data-pb-cd-plus]');
    if (m) {
      var inp = m.parentNode.querySelector('[data-pb-cd-qty]');
      var q = (parseInt(inp.value, 10) || 0) + (m.hasAttribute('data-pb-cd-plus') ? 1 : -1);
      setQty(parseInt(inp.dataset.line, 10), Math.max(q, 0));
      return;
    }
    var rm = t.closest('[data-pb-cd-remove]');
    if (rm) setQty(parseInt(rm.dataset.line, 10), 0);
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-pb-cd-qty]')) {
      setQty(parseInt(t.dataset.line, 10), Math.max(parseInt(t.value, 10) || 0, 0));
    } else if (t.matches && t.matches('[data-pb-cd-sp]')) {
      var v = parseInt(t.dataset.variant, 10);
      if (!v) { t.checked = false; return; }
      if (t.checked) post('/cart/add.js', { items: [{ id: v, quantity: 1 }] });
      else setQty(v, 0);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

// show Canadian dollars as "C$" instead of "CA$" everywhere on the page
(function () {
  var fix = function (node) {
    var w = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      if (n.nodeValue.indexOf('CA$') > -1) n.nodeValue = n.nodeValue.replace(/CA\$/g, 'C$');
    }
  };
  var run = function () {
    fix(document.body);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'characterData') { if (m.target.nodeValue.indexOf('CA$') > -1) m.target.nodeValue = m.target.nodeValue.replace(/CA\$/g, 'C$'); }
        else m.addedNodes.forEach(function (a) { fix(a.nodeType === 3 ? a.parentNode : a); });
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.body) run(); else document.addEventListener('DOMContentLoaded', run);
})();
